import { FillPause, LockBadge, playButton, PreviewPauseButton, PreviewPlayButton, TrackedPause, TrackedPlay } from "../../Assets/svg";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { activeUser } from "../../Store/Slices/APIs";
import { addPlaylistTracks, addSingleTrack, appendTracksToPlaylist, playAllTracks, removeAllTracks, removeSingleTrack, setConfig, setSelectedId, setSelectedItem, togglePlayPause } from "../../Store/Slices/PlayerSlice";
import { handleMixTrayGlobal, setIsMixSaved, setMixSavedId } from "../../Store/Slices/SaveMixSlice";
import { getPlaylistType, GetSelectedTrackIdByPlaylistType, InitPlaylistTrackingIds, showPlaylistOption } from "../../Util/helpers";
import AddToPlaylistButton from "../BottomPlayerBar/Playlist/AddToPlaylistButton";
import { Link } from "react-router-dom";
import { ShuffleIcon } from "../../Util/icons";
import { PlayAllBG, PlayAllTracksButton } from "../../Assets/images";
import "./style.css";

const PlayAllBanner = (props) => {

    const dispatch = useDispatch();

    const tracks = useSelector((state) => state.player.playingTracks);
    const config = useSelector((state) => state.player.config);
    const isPlaying = useSelector((state) => state.player.isPlaying);
    const [isSelected, setIsSelected] = useState(false);

    useEffect(() => {
        setIsSelected(config['id'] === props?.item.id);
    }, [tracks, props?.item.id]);

    const handleCardClick = (isShuffle) => {
        if (!isSelected) {
            const data = props?.tracks || [];

            if (data.length === 0) return;

            // activate user
            dispatch(activeUser());
            dispatch(removeAllTracks());
            // set the playing config for player
            dispatch(
                setConfig({
                    id: props?.item.id,
                    type: "playlist",
                    playlist_type: 'music_lullaby',
                    name: props?.item?.title || props?.item?.name,
                    data: data,
                    playingId: data[0]?.id,
                    restartId: null,
                    isRepeat: false,
                    isShuffle: isShuffle,
                    isPlaylist: false,
                    isPlaylistMix: false,
                    is_system_playlist: true,
                })
            );

            setTimeout(() => {
                InitPlaylistTrackingIds(data[0]?.id);
                dispatch(addPlaylistTracks({ data }));
                dispatch(setSelectedId(props?.item.id));
                dispatch(setSelectedItem(data));
                dispatch(playAllTracks(true));
                dispatch(handleMixTrayGlobal(true));
            });
        } else {
            if (isShuffle) {
                dispatch(
                    setConfig({
                        isShuffle: !config.isShuffle,
                    })
                );
            } else {
                dispatch(togglePlayPause());
            }
        }
    };

    if (props?.tracks.length === 0) return null;

    return (
        <div className={`play_all_category_banner`}
            style={{
                backgroundImage: `url(${PlayAllBG})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right center',
                backgroundColor: '#ffffff2b',
            }}
        >

            <div className="d-flex gap-3 align-items-center">
                {/* <button onClick={() => handleCardClick(false)} className="play_all_category_play_button flex-shrink-0" style={{
                    backgroundImage: `url(${PlayAllTracksButton})`,
                    backgroundSize: '52px 52px',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundColor: '#ffffff2b',
                }}>
                    <img className={`${isSelected && isPlaying ? '' : 'selected'}`} src={isSelected && isPlaying ? PreviewPauseButton : PreviewPlayButton} />
                </button> */}

                <button type="button" className="audioStripButton audioStripPlay" onClick={() => handleCardClick(false)}>
                    {isSelected && isPlaying ? (<img src={TrackedPause} />) : (<img src={TrackedPlay} />)}
                </button>

                <div className="align-self-center">
                    <h4 className="text-white play_all_text mb-0">Play All</h4>
                    {/* <p className="text-white mb-0 fw-light play_all_text_description">Play All songs in this category</p> */}
                </div>

            </div>
            <div className="audioStripExtra ms-auto">
                {/* <button type="button" className="audioStripButton audioStripPlay" onClick={handleCardClick}>
                    {isSelected && isPlaying ? (<img src={FillPause} />) : (<img src={TrackedPlay} />)}
                </button> */}
                <p className="text-white mb-0 fw-light play_all_text_description" style={{ whiteSpace: 'nowrap' }}>Shuffle</p>
                <button type="button" className="audioStripButton audioStripPlay" style={{ width: '40px', backgroundColor: config.isShuffle ? '#f7ba31' : '#081c3f' }} onClick={() => handleCardClick(true)}>
                    <ShuffleIcon />
                </button>
            </div>
        </div>
    );


};

export default PlayAllBanner;
